import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { L10nProvider, L10nTranslationLoader } from 'angular-l10n';
import { Observable, of } from 'rxjs';

@Injectable()
export class HttpTranslationLoader implements L10nTranslationLoader {
  private http = inject(HttpClient, { optional: true });

  private headers = { 'Content-Type': 'application/json' };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public get(language: string, provider: L10nProvider): Observable<{ [key: string]: any }> {
    const url = `${provider.asset as string}-${language}.json`;
    const options = {
      headers: this.headers,
      params: { v: provider.options.version as string | number | boolean },
    };
    return this.http?.get(url, options) ?? of({});
  }
}
